export default "__VITE_ASSET__Dank3_I6__"